import { memo, useMemo } from "react";

// Memoized Location Details
export const LocationDetails = memo(
	({ addressData, mapCenter }: { addressData: string | null; mapCenter: { lat: number; lng: number } | null }) => {
		const displayText = useMemo(() => {
			if (addressData) return addressData;
			if (mapCenter) return `${mapCenter.lat.toFixed(6)}, ${mapCenter.lng.toFixed(6)}`;
			return "";
		}, [addressData, mapCenter]);

		return (
			<div className="space-y-1">
				<h2 className="text-lg font-semibold text-neutral-900">Location Details</h2>
				<p className="text-sm text-neutral-600">{displayText}</p>
			</div>
		);
	},
);

LocationDetails.displayName = "LocationDetails";
